<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="客户名称/手机号/订单号">
          <el-input placeholder="请输入客户名称/手机号/订单号" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item label="医生">
          <el-input placeholder="请输入医生" v-model="formInline.ysearch">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">


            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column prop="transaction_id" label="微信单号"></el-table-column>
      
            <el-table-column prop="user.nickName" label="用户"></el-table-column>
            <el-table-column prop="user.mobile" label="手机号"></el-table-column>

            <el-table-column prop="name" label="预约信息" width="170">
              <template slot-scope="scope">
               <div>预约姓名:{{ scope.row.name }}</div> 
               <div>预约医生:{{ scope.row.doctor.name }}</div> 
               <div>预约时间:{{ scope.row.date }}</div> 
              </template>
            </el-table-column>

            <el-table-column prop="pay_price" label="预约费用"></el-table-column>
            <el-table-column prop="pay_type_text" label="支付类型"></el-table-column>
            <el-table-column prop="pay_status_text" label="支付状态"></el-table-column>


            <el-table-column prop="hques.name" label="预约问诊名称"></el-table-column>

            <el-table-column prop="status_text" label="状态"></el-table-column>

            <el-table-column prop="finish_times" label="用时" ></el-table-column>
            <el-table-column prop="finish_time" label="完成时间" width="120"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="120"></el-table-column>

            <el-table-column prop="refund_number" label="退款单号"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="pre(scope.row)" style="margin-left: 0px !important;" type="text" size="small">预览</el-button>
                <el-button v-if="scope.row.status == 0&&scope.row.pay_status == 20" style="margin-left: 0px !important;"  @click="finish(scope.row)" type="text" size="small">是否完成</el-button>
                <el-button @click="deleteClick(scope.row)" style="margin-left: 0px !important;"  type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import HquessubApi from '@/api/hquessub.js';

  export default {
    components: {
  
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          ysearch:"",
        },

        open_add:false,
        open_edit:false,
        hques_sub_id:"",
        dialogVisible:false,
        open_tz:false,
        hques_sub_id:0,

      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      pre(item){
        var url = 'http://hxing.1.y01.cn';//window.location.protocol + '//' + window.location.host+
      window.open(url+'/h5/#/plus2/pages/hques/pre?hques_id='
      +item.hques.hques_id+'&type=4&user_id='+item.user_id)
      },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
      introClick(row,code){
        this.open_tz=true;
        this.obj = row
        this.code = code
        this.hques_sub_id = row.hques_sub_id;
      },
      closeTz(e){
      this.open_tz=false;

      this.getTableList();
    },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        HquessubApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.hques_sub_id = row.hques_sub_id;
        this.open_edit = true
      },
      finish(row) {
        let self = this;
        self
          .$confirm('是否完成这次预约?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            HquessubApi.finish(
              {
                doctor_yy_id: row.doctor_yy_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            HquessubApi.del(
              {
                hques_sub_id: row.hques_sub_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/hospital/hques/index/yy.vue